<template>
    <div class="text-start">
        <template v-for="(type, key) in sizeTypes">
            <!-- Different Front and Back sizes with multiple options -->
            <template v-if="key == 'front/rear/same/diff/multiple' && type == true">
                <p>Your front and rear tyres could be the same size <b>OR</b> you may have different size front and rear tyres.</p>
                <p>If you wish to add front &amp; rear tyres in one order you will be given the option to add the other after your first tyre choice.</p>
            </template>
            <!-- Front & Rear the same with 1 option or multiple options -->
            <template v-else-if="(key == 'front/rear/same/single' || key == 'front/rear/same/multiple') && type == true">
                <p>Your front &amp; rear tyre sizes are the same.</p>
                <p>You can add as many tyres as you need for your order, and they'll fit on either side of your car.</p>
            </template>
            <!-- Different Front and Back sizes with multiple options and no same options -->
            <template v-else-if="key == 'front/rear/diff/multiple' && type == true">
                <p>You have several tyre options available.</p>
                <p>If you wish to add front &amp; rear tyres in one order you will be given the option to add the other after your first tyre choice.</p>
            </template>
            <template v-if="key == 'front/rear/diff/single' && type == true">
                <p>You have different size front and rear tyre options available.</p>
                <p>If you wish to add front &amp; rear tyres in one order you will be given the option to add the other after your first tyre choice.</p>
            </template>
        </template>
    </div>
</template>

<script>
    export default {
        props: ['sizeTypes']
    }
</script>

<style lang="scss" scoped>

</style>